import { ModuleDeviceRequirements } from "features/module/types";

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 730,
  desktopOnly: true // Due to react-sortable-hoc's lack of touch support
};
